/**
 * Ref callback for autoplay `<video>` elements that must stay silent.
 *
 * React applies `muted` as a DOM *property*, not an HTML *attribute*, so it is
 * absent from prerendered static HTML (public routes are prerendered via a
 * headless-browser DOM snapshot). Without the attribute the browser autoplays
 * the video WITH sound on first load until React hydrates — a few seconds of
 * unwanted audio (most audible during the en→he language switch for new IL
 * visitors). `defaultMuted` reflects to the `muted` attribute, so setting it on
 * mount lands `muted` in the prerendered HTML — the video is silent from the
 * very first frame, before any JS runs.
 *
 * Usage: `<video ref={muteVideoRef} autoPlay loop playsInline ... />`.
 * For a video that also needs its own ref, compose:
 *   `ref={(el) => { myRef.current = el; muteVideoRef(el); }}`
 */
export function muteVideoRef(el: HTMLVideoElement | null): void {
  if (!el) return;
  el.defaultMuted = true;
  el.muted = true;
}
